






















import { Component, Vue } from 'vue-property-decorator';
import TmsTable from '@/shared/components/table/TmsTable.vue';
import { TableHeaders } from '@/shared/components/table/models';

import { EGHeaders } from './models/EGHeaders';

import EGFilters from '@/pages/EDI/EG/EGFilters.vue';
import EGAction from '@/pages/EDI/EG/EGAction.vue';

@Component({
  components: { TmsTable, EGAction, EGFilters }
})
export default class DailyInOut extends Vue {
  columns: TableHeaders[] = EGHeaders;
  inventory: any = {};

  get rows() {
    const a = [];
    for (let index = 0; index < 100; index++) {
      a.push({
        category: `caategory${index}`,
        date: '20210428000000',
        orderNumber: `aaaa${index}`,
        billTo: `bill to ${index}`,
        containerNumber: `number124 ${index}`
      });
    }
    return a;
  }

  constructor() {
    super();
  }

  openModal(a, b) {
    console.log(a, b);
    this.$bvModal.show('inventory-action-modal');
  }
}
